export default __webpack_public_path__ + "gift-box.png";